// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "baby.smart",
    name: "Smart.Baby",
    homepage: "https://smart.baby",
    image_id: "7f408502-e3d1-48f1-a81f-654a3f338f00",
    app: {
        browser: null,
        ios: null,
        android: "https://smartbaby.oss-cn-hongkong.aliyuncs.com/wallet/20230912/e94cee9101074e54a717415cccd11a87.apk",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "smartbody://?uri=",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map